import React from "react"

function Tree({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.8 23.4C11 23 9 21.1 8.7 18.7C8.4 16.2 10 13.8 12.4 13.2C13.1 13 13.6 12.5 13.8 11.8C14.3 10 15.9 8.8 18 8.8C20.1 8.8 21.7 10 22.2 11.8C22.4 12.5 22.9 13 23.6 13.2C26 13.8 27.6 16.2 27.3 18.7C27 21.1 25 23 22.2 23.4H13.8Z"
        stroke="#003E4C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 15V28"
        stroke="#003E4C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 16.8L17.6 20.4"
        stroke="#003E4C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 16.8L18.4 20.4"
        stroke="#003E4C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Tree
